<template lang="pug">
  .root
    component-header-index
    div(class="container-flex")
      div(class="leftContainer")
        div(class="bread-list") >>
          span(class="display-title") プロフィールを変更

        div(:class="ui.tab === '' ? 'prof-left-content' : 'prof-left-content content-dn'")
          div(v-if="!ui.isConfirm")
            div(class="prof-account-head")
              div(class="prof-account-sns")
                img(@click="onSnsProfile()" src="/img/socil_twitter.png")

              div(class="prof-account-img")
                img(v-if="$store.state.user.profile_avatar_store_path" :src="$store.state.system.config.storage_addr_list.public + $store.state.user.profile_avatar_store_path")
                img(v-else src="/img/default_avatar.png")
                component-image-upload-index(:fatherInit="init" :mode="'avaterUpload'")

              div(class="prof-link-pc")
                a(v-if="data.country === '日本'" @click="$router.push({ name: 'TopProfileAddress' })") >>住所の登録/変更
                //a(@click="$router.push({ name: 'TopProfileAddress' })") >>住所の登録/変更
                a(@click="onChangeMail()") >>メールアドレスの変更
                a(@click="onChangePassword()") >>パスワードの変更
            div(class="caution-t" style="text-align:center") ※比率1:1、300KB以上の際は圧縮いたします（推奨サイズ：200×200ピクセル、300KB以下）
            div(class="prof-account-detail")
              div(class="prof-account-detail-name") アカウントID: {{ data.profile.account_id }}
              div(v-if="!isNamePassCheck" style="color:red;margin-top:20px") NGワードが含まれています
              div(v-if="isAccountNameLengthOver" style="color:red;margin-top:20px") 文字数が超過しています
              div アカウント名 ※全角20文字/半角40文字以内

              input(v-model.trim="data.profile.account_name" class="input-g-border" @input="checkNameInput()")

              div 属性
              div(v-if="waiting_update_attribute")
                span(class="font-red") ※属性の反映は24時に行われます
                select(v-model="waiting_update_attribute" class="input-g-border")
                  option(v-for="option in ui.type" :value="option.value") {{ option.name }}
              div(v-else)
                select(v-model="data.profile.attribute" class="input-g-border")
                  option(v-for="option in ui.type" :value="option.value") {{ option.name }}

              div(v-if="user_titles.includes($store.state.system.enum_list.title_list.ZEUS) || user_titles.includes($store.state.system.enum_list.title_list.GODDESS)")
                div ゴッド
                select(v-model="select_title" class="input-g-border")
                  option(v-for="option in ui.god_titles" :value="option.value") {{ option.name }}

              div(v-if="!isIntroductionPassCheck" style="color:red;margin-top:20px") NGワードが含まれています
              div(v-if="isIntroductionLengthOver" style="color:red;margin-top:20px") 文字数が超過しています
              div 自己紹介文 ※全角160文字/半角320文字以内
              div(class="textarea_content")
                textarea(v-model="data.profile.introduction" type="text" rows="3" class="input-g-border" @input="checkIntroductionInput()")
                div(class="textarea_count") {{data.profile.introduction ? data.profile.introduction.length : 0}}/160

              div 住んでいる国
              select(v-model="data.country" class="input-g-border")
                option(v-for="option in ui.country" :value="option") {{ option }}

              div(v-if="data.country == '日本'")
                div 住んでいる地域
                select(v-model="data.province"  class="input-g-border")
                  option(v-for="option in ui.province" :value="option") {{ option }}
              br/

              div(style="color: red;") {{ ui.errorMessage }}
              div(class="prof-account-detail-button")
                div( class="Login_icon" @click="onOK()" ) <img src="/img/kakunin.png">

            div(class="prof-link-sp")
              a(@click="onChangeMail()") >>メールアドレスの変更
              a(v-if="data.country === '日本'" @click="$router.push({ name: 'TopProfileAddress' })") >>住所の登録/変更
              a(@click="onChangePassword()") >>パスワードの変更

          div(v-if="ui.isConfirm")
            div アカウント名: {{ data.profile.account_name }}
            div 属性: {{ attrString }}
            div( v-if="select_title" ) ゴッド: {{ attrGod }}
            div 自己紹介文: {{ data.profile.introduction }}
            div 住んでいる国: {{ data.country }}
            div( v-if="data.country=='日本'" ) 住んでいる地域: {{ data.province }}

            div(class="confirm-bottom")
              div この内容でよろしいですか？
              div(class="confirm-button")
                button(@click="onConfirm()" class="pink-button") はい
                button(@click="onBack()" class="pink-button") いいえ

      div(class="rightContainer")
        div(v-if="isChangeMail" class="right-content-border")
          button(@click="onClose()" class="close-button") <i class="fas fa-times"></i>
          div(class="bread-list") >>
            span(class="display-title") メールアドレスの変更
          div 入力されたメールアドレスへ「メールアドレス変更 URL」を記載したメールをお送りします。
          div この URL をクリックし、メールアドレスの変更を完了させてください。
          div(class="m-b") メールアドレスを変更するとサイトからログアウトされます。変更したメールアドレスで再度ログインしてください。
          div [注意]
          div 届いたメールのドメインが「@a-live.tokyo」であることを確認してください。
          div 本ドメイン以外のメールは偽物ですので、URL 等は絶対に開かないようにしてください。
          div 変更前のメールアドレスではログインできなくなります。
          div Aライブがメール等の返信で登録しているメールアドレスを要求することはありません。
          p
          div(class="m-b") 変更後メールアドレス
            input(v-model="mail" class="input-g-w-border" autocapitalize="off")
          div(class="m-b") 変更後メールアドレス[確認用]
            input(v-model="mailConfirm" class="input-g-w-border" autocapitalize="off")
          div(style="color: red;") {{ ui.errorMessageMail }}
          div(class="t-c")
            button(@click="onChangeEmailSendCode()" class="pink-button m-b") 変更URLを発行

        div(v-if="isChangePassword" class="right-content-border")
          button(@click="onClose()" class="close-button") <i class="fas fa-times"></i>
          div(class="bread-list") >>
            span(class="display-title") パスワードの変更
          div(class="m-b") パスワードを変更するとサイトからログアウトされます。変更したパスワードで再度ログインしてください。<br>変更したパスワードは必ずメモをして、忘れないようにしてください。
          div(class="m-b") [注意]<br>アカウント名＋誕生日など、個人情報から簡単に推測できるパスワードは大変危険ですのでおやめください。<br>A ライブがメール等の返信でパスワードを要求することはありません。パスワードを第三者に教えないように気を付けて下さい。
          p
            span 変更後パスワード
            label(class="input-password-content")
              input(v-if="psdDisplay" type="text" v-model="password" class="input-g-w-border")
              input(v-else type="password" v-model="password" class="input-g-w-border")
              i(class="fas fa-eye eye-icon" v-show="!psdDisplay" @click="psdDisplay=!psdDisplay")
              i(class="fas fa-eye-slash eye-icon" v-show="psdDisplay" @click="psdDisplay=!psdDisplay")
          div(class="m-b")
            span 変更後パスワード[確認用]
            label(class="input-password-content")
              input(v-if="psdDisplay2" type="text" v-model="passwordConfirm" class="input-g-w-border")
              input(v-else type="password" v-model="passwordConfirm" class="input-g-w-border")
              i(class="fas fa-eye eye-icon" v-show="!psdDisplay2" @click="psdDisplay2=!psdDisplay2")
              i(class="fas fa-eye-slash eye-icon" v-show="psdDisplay2" @click="psdDisplay2=!psdDisplay2")
          div(style="color: red;") ※パスワードは英数字混在の8～16桁で設定してください
          div(style="color: red;") {{ this.ui.errorMessagePass }}
          div(class="right-content-button")
            div(@click="onChangePasswordConfirm()" ) <img src="/img/henkou_p.png">

        div(v-if="isSnsProfile" class="right-content-border")
          button(@click="onClose()" class="close-button") <i class="fas fa-times"></i>
          div(class="m-b") SNSリンク
            div(class="sns-link-content")
              div(class="sns-link-content-item")
                img(src="/img/socil_twitter.png")
                input(v-model="data.profile.sns_infos.twitter" class="input-g-w-border")

            div(class="t-c")
              button(@click="onSnsConfirm()" class="pink-button") 保存する

    component-footer-index
</template>

<style src="./Change.scss" lang="scss" scoped>

</style>

<script>
import { setUserInfo, getUserinfoById, setPassword, sendEmailCode } from '@/api/user'
import { getSystemNgWord } from '@/api/system';
import Mint from 'mint-filter'
import { countLength, isSmartPhone } from '@/utils/tools'

export default {
  name: "TopProfileChange",
  components: {
  },
  data() {
    return {
      mail: '',
      mailConfirm: '',
      mailConfirmCode: '',
      password: '',
      passwordConfirm: '',
      psdDisplay:false,
      psdDisplay2:false,
      form: {
        accountName: '',
        type: '',
        desc: '',
        country: '',
        province: '',
      },
      ui: {
        errorMessage: '',
        errorMessagePass: '',
        errorMessageMail: '' ,
        showError: false,       
        isChangeMail: false,
        isChangePassword: false,
        isConfirm: false,
        type: [],
        god_titles: [],
        country: ['日本', 'アフガニスタン', 'アルバニア', 'アルジェリア', 'アンドラ', 'アンゴラ', 'アンティグア・バーブーダ', 'アルゼンチン', 'アルメニア', 'オーストラリア', 'オーストリア', 'バハマ', 'バーレーン', 'バングラデシュ', 'バルバドス', 'ベラルーシ', 'ベルギー', 'ベリーズ', 'ベニン', 'ブータン', 'ボリビア', 'ボスニア・ヘルツェゴビナ', 'ボツワナ', 'ブラジル', 'ブルネイ', 'ブルガリア', 'ブルキナファソ', 'ブルンジ', 'カーボベルデ', 'カンボジア', 'カメルーン', 'カナダ', '中央アフリカ共和国', 'チャド', 'チリ', '中国', 'コロンビア', 'コモロ', 'コンゴ', 'コスタリカ', 'コートジボアール', 'クロアチア', 'キューバ', 'キプロス', 'チェコ', '朝鮮民主主義人民共和国', 'コンゴ民主共和国', 'デンマーク', 'ジブチ', 'ドミニカ', 'ドミニカ共和国', 'エクアドル', 'エジプト', 'エルサルバドル', '赤道ギニア', 'エリトリア', 'エストニア', 'エスワティニ', 'エチオピア', 'フィジ.', 'フィンランド', 'フランス', 'ガボン', 'ガンビア', 'ジョージア', 'ドイツ', 'ガーナ', 'ギリシャ', 'グレナダ', 'グアテマラ', 'ギニア', 'ギニアビサウ', 'ガイアナ', 'ハイチ', 'ホンジュラス', 'ハンガリ. ', 'アイスランド', 'インド', 'インドネシア', 'イラン', 'イラク', 'アイルランド', 'イスラエル', 'イタリア', 'ジャマイカ', 'ヨルダン', 'カザフスタン', 'ケニア', 'キリバス', 'クウェート', 'キルギスタン', 'ラオス人民民主共和国', 'ラトビア', 'レバノン', 'レソト', 'リベリア', 'リビア', 'リヒテンシュタイン', 'リトアニア', 'ルクセンブルク', 'マダガスカル ', 'マラウィ', 'マレーシア', 'モルディブ', 'マリ ', 'マルタ', 'マーシャル諸島', 'モーリタニア', 'モーリシャス', 'メキシコ', 'ミクロネシア連邦', 'モナコ', 'モンゴル', 'モンテネグロ', 'モロッコ', 'モザンビーク', 'ミャンマー', 'ナミビア', 'ナウル', 'ネパール', 'オランダ', 'ニュージーランド', 'ニカラグア', 'ニジェール', 'ナイジェリア', '北マケドニア', 'ノルウェー', 'オマーン', 'パキスタン', 'パラオ', 'パナマ', 'パプア・ニューギニア', 'パラグアイ', 'ペルー', 'フィリピン', 'ポーランド', 'ポルトガル', 'カタール', '韓国', 'モルドバ', 'ルーマニア', 'ロシア連邦', 'ルワンダ', 'セントクリストファー・ネイビス', 'セントルシア', 'セントビンセントおよびグレナディーン諸島', 'サモア', 'サンマリノ', 'サントメ・プリンシペ', 'サウジアラビア', 'セネガル', 'セルビア', 'セイシェル', 'シエラレオネ', 'シンガポール', 'スロバキア', 'スロベニア', 'ソロモン諸島', 'ソマリア', '南アフリカ', '南スーダン', 'スペイン', 'スリランカ', 'スーダン', 'スリナム', 'スウェーデン', 'スイス', 'シリア', 'タジキスタン', 'タイ', '東ティモール', 'トーゴ', 'トンガ', 'トリニダード・トバゴ ', 'チュニジア', 'トルコ', 'トルクメニスタン', 'ツバル', 'ウガンダ', 'ウクライナ', 'アラブ首長国連邦', '英国', 'タンザニア', '米国', 'ウルグアイ', 'ウズベキスタン', 'バヌアツ', 'ベネズエラ', 'ベトナム', 'イエメン', 'ザンビア', 'ジンバブエ'],
        province: ["北海道", "青森県", "岩手県", "宮城県", "秋田県", "山形県", "福島県", "茨城県", "栃木県", "群馬県", "埼玉県", "千葉県", "東京都", "神奈川県", "新潟県", "富山県", "石川県", "福井県", "山梨県", "長野県", "岐阜県", "静岡県", "愛知県", "三重県", "滋賀県", "京都府", "大阪府", "兵庫県", "奈良県", "和歌山県", "鳥取県", "島根県", "岡山県", "広島県", "山口県", "徳島県", "香川県", "愛媛県", "高知県", "福岡県", "佐賀県", "長崎県", "熊本県", "大分県", "宮崎県", "鹿児島県", "沖縄県"],
        tab:'',
      },
      data: {
        profile: {
          sns_infos: {
            twitter: ''
          }
        }
      },
      user_titles: [],
      select_title: '',
      attr_raw: undefined,
      waiting_update_attribute: null,
      shopId: '',
      NgWordList: [],
      mint: {},
      isMintInited: false,
      isNamePassCheck: true,
      isIntroductionPassCheck: true,
      accountNameLength: '',
      introductionLength: ''
    }
  },
  computed: {
    attrString() {
      if (this.waiting_update_attribute) {
        return this.getAttributeString(this.waiting_update_attribute);
      }
      return this.getAttributeString(this.data.profile.attribute);
    },
    attrGod() {
      if (this.select_title === this.$store.state.system.enum_list.title_list.ZEUS) {
        return 'ゼウス';
      } else if (this.select_title === this.$store.state.system.enum_list.title_list.GODDESS) {
        return '女神';
      }
      return '';
    },
    isChangeMail(){
      return this.ui.tab === "ChangeMail"
    },
    isChangePassword(){
      return this.ui.tab === "ChangePassword"
    },
    isSnsProfile(){
      return this.ui.tab === "SnsProfile"
    },
    isAccountNameLengthOver() {
      return this.accountNameLength > 40;
    },
    isIntroductionLengthOver() {
      return this.introductionLength > 320;
    }
  },
  async created() {
    this.ui.type = [
      { name: '無属性', value: this.$store.state.system.enum_list.attribute_list.NONE },
      { name: '炎属性', value: this.$store.state.system.enum_list.attribute_list.FIRE },
      { name: '氷属性', value: this.$store.state.system.enum_list.attribute_list.ICE },
      { name: '風属性', value: this.$store.state.system.enum_list.attribute_list.WIND },
      { name: '地属性', value: this.$store.state.system.enum_list.attribute_list.EARTH },
    ];
    this.ui.god_titles = [
      { name: 'ゼウス', value: this.$store.state.system.enum_list.title_list.ZEUS },
      { name: '女神', value: this.$store.state.system.enum_list.title_list.GODDESS},
    ];
    await this.init();

  },
  mounted(){
  },
  methods: {
    async init() {
      const { data } = await getUserinfoById(this.$store.state.user.profile_profileable_id);
      if (!data.profile.sns_infos) {
        data.profile.sns_infos = {
          twitter: '',
        }
      }
      this.data = data;
      this.attr_raw = this.data.profile.attribute;
      this.waiting_update_attribute = this.data.waiting_update_attribute;
      this.user_titles = this.data.profile.profileable.titles;
      if (this.data.profile.profileable.titles.includes(this.$store.state.system.enum_list.title_list.ZEUS)){
        this.select_title = this.$store.state.system.enum_list.title_list.ZEUS;
      }
      if (this.data.current_title == this.$store.state.system.enum_list.title_list.ZEUS){
        this.select_title = this.$store.state.system.enum_list.title_list.ZEUS;
      } else if (this.data.current_title == this.$store.state.system.enum_list.title_list.GODDESS) {
        this.select_title = this.$store.state.system.enum_list.title_list.GODDESS;
      }
      this.initMint()
    },
    onOK() {
      this.checkNameInput()
      this.checkIntroductionInput()
      if(this.accountNameLength === 0) {
        this.ui.showError = true;
        this.ui.errorMessage = '※[アカウント名]を入力してください';
        return
      }
      if(!this.isNamePassCheck || !this.isIntroductionPassCheck) {
        this.ui.showError = true;
        this.ui.errorMessage = 'NGワードが含まれています';
        return
      }
      if(this.accountNameLength > 40) {
        this.ui.showError = true;
        this.ui.errorMessage = 'アカウント名の文字数が超過しています';
        return
      }
      if(this.introductionLength > 320) {
        this.ui.showError = true;
        this.ui.errorMessage = '自己紹介文の文字数が超過しています';
        return
      }
      this.ui.isConfirm = true;
    },

    async onConfirm() {
      this.checkNameInput()
      this.checkIntroductionInput()
      if(!this.isNamePassCheck || !this.isIntroductionPassCheck) {
        this.$alert('NGワードが含まれています')
        return
      }
      if(this.data.profile.account_name){
        this.setTitle()
        this.data.profile.avatar_store_path = this.$store.state.user.profile_avatar_store_path;
        this.data.profile.background_store_path = this.$store.state.user.profile_background_store_path;
        await setUserInfo(this.data)
        .then(async ()=>{
          await this.$alert('マイプロフィールを更新しました')
        })
        .catch(async ()=>{
          await this.$alert('システムエラー', '', {
            type: 'error'
          })
        });
        if (this.waiting_update_attribute && this.attr_raw !== this.waiting_update_attribute) {
          await this.$store.dispatch('user/setAttribute', this.waiting_update_attribute)
        } else if (this.attr_raw !== this.data.profile.attribute) {
          await this.$store.dispatch('user/setAttribute', this.data.profile.attribute);
        }
        await this.$store.dispatch('user/syncProfile');
        await this.init();
        this.ui.isConfirm = false;
      } else {
        this.$message({
          message: 'アカウント名が未入力です',
        })
      }
    },

    async onSnsConfirm() {
      const reg = /^https:\/\/twitter.com\/\.*/
      const isTwitter = reg.test(this.data.profile.sns_infos.twitter)
      if (!isTwitter) {
        this.$alert('https://twitter.com/から始まるリンク以外は設定できません')
        return
      }
      this.setTitle()
      await setUserInfo(this.data);
      await this.$store.dispatch('user/syncProfile');
      await this.init();
      this.ui.isConfirm = false;
      this.ui.tab = '';
      this.$message({
        showClose: true,
        message: '保存が完了しました',
        type: 'success'
      })
    },

    setTitle() {
      if (this.select_title) {
        this.data.current_title = this.select_title;
      }
      if(this.data.current_title === null) {
        delete this.data.current_title
      }
    },

    onBack() {
      this.ui.isConfirm = false;
    },

    onClose() {
      this.ui.isChangePassword = false;
      this.ui.isChangeMail = false;
      this.ui.tab = ''
    },

    onChangeMail() {
      if (isSmartPhone()) {
        this.$router.push({ name: 'TopProfileChangeMail' })
      } else {
        this.ui.tab = 'ChangeMail'
        this.ui.showError = false;
      }
    },

    onChangePassword() {
      if (isSmartPhone()) {
        this.$router.push({ name: 'TopProfileChangePassword' })
      } else {
        this.ui.tab = 'ChangePassword'
        this.ui.showError = false;
      }
    },

    onSnsProfile() {
      this.ui.tab = 'SnsProfile'
      this.ui.showError = false;
    },

    checkMail() {
      // メールアドレス正規表現
      let re = /^[A-Za-z0-9]{1}[A-Za-z0-9_+.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
      if (!this.mail) {
        this.ui.showError = true;
        this.ui.errorMessageMail = '※メールアドレスが入力されていません';
        return false;
      } else if (this.mail && this.mailConfirm !== this.mail) {
        this.ui.showError = true;
        this.ui.errorMessageMail = '※確認用のメールアドレスが一致していません';
        return false;
      } else if (
        this.mail.includes(' ') || this.mail.includes('　')
      ) {
        this.ui.showError = true;
        this.ui.errorMessageMail = 'スペースは入れずにご入力ください';
        return false;
      } else if (
        !re.test(this.mail)
      ){
        this.ui.showError = true;
        this.ui.errorMessageMail = '※メールアドレスが正しい形式ではありません';
        return false;
      }
      return true;
    },

    getAttributeString(attribute) {
      const attribute_list = this.$store.state.system.enum_list.attribute_list;
      switch(attribute) {
        case attribute_list.FIRE:
          return '炎属性';
        case attribute_list.ICE:
          return '氷属性';
        case attribute_list.WIND:
          return '風属性';
        case attribute_list.EARTH:
          return '地属性';
        case attribute_list.NONE:
        default:
          return '無属性';
      }
    },

    async onChangeEmailSendCode() {
      if (!this.checkMail()) {
        return;
      }
      try{
        const { data } = await sendEmailCode(this.mail);
        this.ui.showError = true;
        if (data[0]) {
          this.ui.errorMessageMail = '確認URLの発行が完了しました。';
        } else {
          this.ui.errorMessageMail = 'エラーが発生しました。';
        }
      } catch(e) {
        this.ui.errorMessageMail = 'エラーが発生しました。';
      }
    },

    // async onChangeEmailConfirm() {
    //   if (!this.checkMail()) {
    //     return;
    //   }
    //   if (!this.mailConfirmCode) {
    //     this.ui.showError = true;
    //     this.ui.errorMessage = '確認コードを入力してください。';
    //   }
    //   await setEmail(this.mail, this.mailConfirmCode);
    //   await this.$store.dispatch('user/logout').then(() => {
    //     this.$router.push({ name: 'LoginIndex', query: { from_email: true } })
    //   })
    // },

    async onChangePasswordConfirm() {
      const pwdArray = 'qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890'.split('');
      const pwdEnglishArray = 'qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM'.split('');
      const pwdNumberArray = '1234567890'.split('');

      const pwdInputArray = this.password.split('');

      if (this.password && this.passwordConfirm !== this.password) {
        this.ui.showError = true;
        this.ui.errorMessagePass = '※確認用のパスワードが一致していません。';
        return;
      } else if (
        this.password.includes(' ') || this.password.includes('　')
      ) {
        this.ui.showError = true;
        this.ui.errorMessagePass = 'スペースは入れずにご入力ください';
        return;
      } else if(
        this.password.length === 0
      ) {
        this.ui.showError = true;
        this.ui.errorMessagePass = '※パスワードが入力されていません';
        return;
      } else if (
        this.password.length < 8 ||
        this.password.length > 16 ||
        !pwdInputArray.every(v => pwdArray.includes(v)) ||
        !pwdInputArray.some(v => pwdEnglishArray.includes(v)) ||
        !pwdInputArray.some(v => pwdNumberArray.includes(v))
      ) {
        this.ui.showError = true;
        this.ui.errorMessagePass = '※英数字が混在しているか8～16桁になっているか確認してください';
        return;
      }

      await setPassword(this.password);
      await this.$store.dispatch('user/logout').then(() => {
        this.$router.push({ name: 'LoginIndex', query: { from_password: true } })
      })
    },

    // NGワードチャックInit
    async initMint(){
      this.isMintInited = false
      const { data } = await getSystemNgWord()
      this.NgWordList = data
      this.mint = new Mint(this.NgWordList)
      this.isMintInited = true
    },

    // 入力のタイミングでNGワードチャック name
    checkNameInput(){
      const regMail = /[\w\-._]+@[\w\-._]+\.[A-Za-z]+/g
      const regUrl = /https?:\/\/[\w!?/+\-_~;.,*&@#$%()'[\]]+/g
      this.accountNameLength = countLength(this.data.profile.account_name);
      this.isNamePassCheck = this.mint.validator(this.data.profile.account_name) && !regMail.test(this.data.profile.account_name) && !regUrl.test(this.data.profile.account_name)
    },

    // 入力のタイミングでNGワードチャック introduction
    checkIntroductionInput(){
      const regMail = /[\w\-._]+@[\w\-._]+\.[A-Za-z]+/g
      const regUrl = /https?:\/\/[\w!?/+\-_~;.,*&@#$%()'[\]]+/g
      this.introductionLength = countLength(this.data.profile.introduction);
      this.isIntroductionPassCheck = this.mint.validator(this.data.profile.introduction) && !regMail.test(this.data.profile.introduction) && !regUrl.test(this.data.profile.introduction)
    },
  }
}
</script>
